






















































import { mapMutations } from 'vuex'
import Vue from 'vue'
import AmataList from '@/components/AmataList.vue'
import AmataListItem from '@/components/AmataListItem.vue'
import { sleep } from '@/utils/helpers'

export default Vue.extend({
  name: 'Select',
  components: {
    AmataList,
    AmataListItem
  },
  data() {
    return {
      ages: this.$route.params.ages || {},
      ageRadio1: this.$store.getters['Search/ageRadio1'],
      ageRadio2: this.$store.getters['Search/ageRadio2'],
      allFukens: this.$store.getters['Search/allFukens'],
      fukens: this.$route.params.fukens || {},
      fukenCheckes: this.$store.getters['Search/fukenCheckes'],
      jobs: this.$store.getters['Search/jobs'],
      types: this.$store.getters['Search/types'],
      charms: this.$store.getters['Search/charms'],
      shutubotus: this.$store.getters['Profile/shutubotus'],
      jobRadio: this.$store.getters['Search/jobRadio'],
      typeRadio: this.$store.getters['Search/typeRadio'],
      charmRadio: this.$store.getters['Search/charmRadio'],
      shutubotuRadio: this.$store.getters['Search/shutubotuRadio'],
      sortList: this.$route.params.sortList || {},
      sortRadio: this.$store.getters['Search/sortRadio']
    }
  },
  computed: {
    title(): string {
      if (this.isAgeType) {
        return '年齢'
      } else if (this.isFukenType) {
        return '地域'
      } else if (this.isSortType) {
        return '並び順'
      } else if (this.isJobType) {
        return '職業'
      } else if (this.isTypeType) {
        return 'タイプ'
      } else if (this.isCharmType) {
        return 'チャームポイント'
      } else if (this.isShutubotuType) {
        return '主な出没時間'
      } else {
        return '選択'
      }
    },

    isAgeType(): boolean {
      return this.$route.params.type === 'age'
    },
    isFukenType(): boolean {
      return this.$route.params.type === 'fuken'
    },
    isJobType(): boolean {
      return this.$route.params.type === 'job'
    },
    isTypeType(): boolean {
      return this.$route.params.type === 'type'
    },
    isCharmType(): boolean {
      return this.$route.params.type === 'charm'
    },
    isShutubotuType(): boolean {
      return this.$route.params.type === 'shutubotu'
    },
    isSortType(): boolean {
      return this.$route.params.type === 'sort'
    }
  },
  watch: {
    $route(val) {
      console.log('[watch $route]', val)
    },
    fukenCheckes(val) {
      if (val.length > 0) {
        this.allFukens = false
      }
    }
  },
  methods: {
    ...mapMutations('Search', [
      'setAgeRadio1',
      'setAgeRadio2',
      'setAllFukens',
      'clearFukenCheckes',
      'setFukenCheckValue',
      'setJobRadio',
      'setTypeRadio',
      'setCharmRadio',
      'setShutubotuRadio',
      'setSortRadio'
    ]),

    /**
     * 選択して検索に戻る
     */
    async saveSelectAndRouterBack() {
      this.saveSelect()
      await sleep(100)
      this.$router.back()
    },

    /**
     * 選択した結果を store に保存する
     */
    saveSelect(this: any) {
      if (this.isAgeType) {
        this.setAgeRadio1(this.ageRadio1)
        this.setAgeRadio2(this.ageRadio2)
      } else if (this.isFukenType) {
        this.setAllFukens(this.allFukens)
        this.clearFukenCheckes()
        for (const value of this.fukenCheckes) {
          this.setFukenCheckValue(value)
        }
      } else if (this.isJobType) {
        this.setJobRadio(this.jobRadio)
      } else if (this.isTypeType) {
        this.setTypeRadio(this.typeRadio)
      } else if (this.isCharmType) {
        this.setCharmRadio(this.charmRadio)
      } else if (this.isShutubotuType) {
        this.setShutubotuRadio(this.shutubotuRadio)
      } else if (this.isSortType) {
        this.setSortRadio(this.sortRadio)
      }
    }
  }
})
